module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/megaphone-a6d5ecae4bc520cbb1da1303fc599b4a.svg";